import SvgIcon from '@mui/material/SvgIcon';

import type { SvgIconProps } from '@mui/material/SvgIcon';

const ReadOnlyIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      height='24'
      viewBox='0 0 24 24'
      width='24'
      {...props}
    >
      <path
        d='M3 21V3H21V13.325C20.6833 13.1417 20.3583 12.975 20.025 12.825C19.6917 12.675 19.35 12.5417 19 12.425V9H13V12.425C12.2333 12.6583 11.5167 12.9917 10.85 13.425C10.1833 13.8583 9.56667 14.3833 9 15H5V19H7.05C7.23333 19.3667 7.41667 19.7167 7.6 20.05C7.78333 20.3833 7.98333 20.7 8.2 21H3ZM5 13H11V9H5V13ZM5 7H19V5H5V7ZM16 23C14.4833 23 13.0833 22.6 11.8 21.8C10.5167 21 9.58333 19.9 9 18.5C9.58333 17.1 10.5167 16 11.8 15.2C13.0833 14.4 14.4833 14 16 14C17.5167 14 18.9167 14.4 20.2 15.2C21.4833 16 22.4167 17.1 23 18.5C22.4167 19.9 21.4833 21 20.2 21.8C18.9167 22.6 17.5167 23 16 23ZM16 21C16.95 21 17.846 20.7833 18.688 20.35C19.53 19.9167 20.2173 19.3 20.75 18.5C20.2167 17.7 19.5293 17.0833 18.688 16.65C17.8467 16.2167 16.9507 16 16 16C15.0493 16 14.1537 16.2167 13.313 16.65C12.4723 17.0833 11.7847 17.7 11.25 18.5C11.7833 19.3 12.471 19.9167 13.313 20.35C14.155 20.7833 15.0507 21 16 21ZM16 20C15.5833 20 15.2293 19.8543 14.938 19.563C14.6467 19.2717 14.5007 18.9173 14.5 18.5C14.4993 18.0827 14.6453 17.7287 14.938 17.438C15.2307 17.1473 15.5847 17.0013 16 17C16.4153 16.9987 16.7697 17.1447 17.063 17.438C17.3563 17.7313 17.502 18.0853 17.5 18.5C17.498 18.9147 17.3523 19.269 17.063 19.563C16.7737 19.857 16.4193 20.0027 16 20Z'
        fill='#F8F8F8'
      />
    </SvgIcon>
  );
};

export default ReadOnlyIcon;
